/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import { useSelector } from "react-redux";
import { selectCompanyBranding } from "../system/whiteLabelling/CompanyBrandingSlice";

const AuthLayout = () => {
  const companyBranding = useSelector(selectCompanyBranding);

  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      root.style.height = "100%";
    }
  }, []);

  return (
    <div className="row h-sm-100 align-items-sm-center">
      {/* begin::Body */}
      <div className="col-sm-12 col-md-6 order-2 order-md-1">
        {/* begin::Form */}
        <div className="d-flex flex-center flex-column">
          {/* begin::Wrapper */}
          <div className="w-100 mw-500px p-10">
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}
      </div>
      {/* end::Body */}

      {/* begin::Aside */}
      <div className="col-sm-12 col-md-6 order-1 order-md-2">
        {/* begin::Content */}
        <div className="d-flex flex-column flex-center py-15 px-5 px-md-15 w-100">
          {/* begin::Logo */}
          <Link to="/" className="mb-12" data-test-id="auth-layout__logo-link">
            <img
              alt="CPL Brand Logo"
              src={companyBranding?.logoUrl ?? toAbsoluteUrl("media/logos/cpl-logo.png")}
              className="mw-100 mh-100 h-auto"
            />
          </Link>
          {/* end::Logo */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::Aside */}
    </div>
  );
};

export { AuthLayout };
